import { getProperty } from 'customer-data-objects/objects/ObjectAccessors';
import FormattedDateTime from 'I18n/components/FormattedDateTime';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { InlineLabel } from 'foundations-components/transitional/components/InlineLabel';
import { jsx as _jsx } from "react/jsx-runtime";
const TaskDueDateProperty = ({
  subject
}) => {
  const dueDateValue = getProperty(subject, 'hs_timestamp');
  if (!dueDateValue) {
    return null;
  }
  return /*#__PURE__*/_jsx(InlineLabel, {
    label: /*#__PURE__*/_jsx("strong", {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "customer-data-board-card.taskDueDate"
      })
    }),
    children: /*#__PURE__*/_jsx(FormattedDateTime, {
      value: Number(getProperty(subject, 'hs_timestamp')),
      format: "ll"
    })
  });
};
export default TaskDueDateProperty;